import { ChatBotInitType } from "../type";
import { loadScriptFile } from "../../../utils";

declare global {
  interface Window {
    _xeno: any;
    _xenoSettings: any;
  }
}

export default class XenoChatBotUtil {
  static initialize(props: ChatBotInitType) {
    window._xenoSettings = {
      identify: function () {
        return {
          id: props.userId,
          name: props.userName
        };
      },
      key: props.botApiKey,
      autoInit: true,
      onInit: () => {
        props.onInit?.();
      }
    };
    this.loadScript(props);
  }

  static loadScript(props: ChatBotInitType) {
    if (this.isBotLoaded) {
      this.reInitialize();
      return;
    }
    loadScriptFile({ url: "https://cdn.xeno.app/chat_loader.js" });
  }

  static reInitialize() {
    window._xeno?.identifyContact();
  }

  static async remove() {
    await window._xeno?.destroy();
  }

  static hide() {
    window._xeno?.hide();
  }

  static async destroy() {
    if (window._xeno?.initialized) {
      await this.remove();
    }
  }

  static get isBotLoaded() {
    return window._xeno;
  }
}
